import { render, staticRenderFns } from "./TPWorkpackage.wrapper.vue?vue&type=template&id=fe5b69d6&"
import script from "./TPWorkpackage.wrapper.vue?vue&type=script&lang=js&"
export * from "./TPWorkpackage.wrapper.vue?vue&type=script&lang=js&"
import style0 from "./TPWorkpackage.wrapper.vue?vue&type=style&index=0&id=fe5b69d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports